/**
 * @generated SignedSource<<2fedbd79fd5a056f5cdc08dbdfe8717a>>
 * @relayHash f007e6a1a06e284145a6e359d559abc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e

import type { ConcreteRequest } from 'relay-runtime';
export type useMovePageHandlerMovePageAfterMutation$variables = {
  pageId: string;
  siblingId: string;
};
export type useMovePageHandlerMovePageAfterMutation$data = {
  readonly movePageAfter: {
    readonly page: {
      readonly id: string | null;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      } | null;
    } | null;
  } | null;
};
export type useMovePageHandlerMovePageAfterMutation = {
  response: useMovePageHandlerMovePageAfterMutation$data;
  variables: useMovePageHandlerMovePageAfterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siblingId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          },
          {
            "kind": "Variable",
            "name": "siblingId",
            "variableName": "siblingId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MovePagePayload",
    "kind": "LinkedField",
    "name": "movePageAfter",
    "plural": false,
    "selections": [
      {
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "Map_LinkType_String",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "editui"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMovePageHandlerMovePageAfterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMovePageHandlerMovePageAfterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f007e6a1a06e284145a6e359d559abc7",
    "id": "2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e",
    "metadata": {},
    "name": "useMovePageHandlerMovePageAfterMutation",
    "operationKind": "mutation",
    "text": "mutation useMovePageHandlerMovePageAfterMutation($pageId:ID!,$siblingId:ID!){movePageAfter(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
  }
};
})();

(node as any).hash = "9d4a33e40b8e98aa3f260ac26bd6fa66";

export default node;
